import { RootState } from "@app/redux/root-reducer";

export const selectSalesPersonState = (store: RootState) =>
  store.salesPersonReducer.salesPerson;

export const selectAddSalesPerson = (store: RootState) =>
  store.salesPersonReducer.addSalesPerson;

export const selectUpdateSalesPerson = (store: RootState) =>
  store.salesPersonReducer.updateSalesPerson;

export const selectDeleteSalesPerson = (store: RootState) =>
  store.salesPersonReducer.deleteSalesPerson;

export const selectAssignCustomerToSalesPerson = (store: RootState) =>
  store.salesPersonReducer.assignCustomerToSalesPerson;

export const selectCustomerState = (store: RootState) =>
  store.salesPersonReducer.customer;

export const selectSalesPersonDetailsState = (store: RootState) =>
  store.salesPersonReducer.salesPersonDetails;

export const selectDeleteAssignCustomersState = (store: RootState) =>
  store.salesPersonReducer.deleteAssignCustomers;
